module.exports = __webpack_public_path__ + "static/media/pentadata.0cccb2d2.png";